@if (content) {
<div [ngClass]="content.background_color">
    @for (item of content.items; track $index) {
    <div class="center c-3-set m-b-0">
        <img class="w-10"
             [dfImage]="item.image"
             [ratio]="1">
        <p class="m-t-1 p2 lh-2"
           [ngClass]="content.font_color || ''"
           [innerHTML]="item.title"></p>
    </div>
    }
</div>
}